import React from 'react'
import WishlistContainer from '../../../../Components/Applications/ECommerce/Wishlist'

export default function Wishlist() {
  return (
    <div className='page-body'>
        <WishlistContainer/>
    </div>
  )
}
